import React from "react";
import styled from "styled-components";
import { CurrencyInput } from "./CurrencyInput";

interface InputProps {
    initialValue: number;
    updateEstimate: (value: number) => void;
}
const TradeInEstimateWrapper = styled("div")``;

const TradeInEstimateInput = ({ initialValue, updateEstimate }: InputProps) => {
    const handleUpdateEstimate = (newValue: number) => {
        updateEstimate(newValue);
    };
    return (
        <TradeInEstimateWrapper>
            <CurrencyInput
                value={initialValue}
                className="CalculatorSlider__input"
                updateValue={handleUpdateEstimate}
            />
        </TradeInEstimateWrapper>
    );
};

export default TradeInEstimateInput;
